import { useState } from "react";
import { Link } from "react-router-dom";
import {
  Tabs, TabsContent, TabsList, TabsTrigger,
} from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import { ArrowLeft } from "lucide-react";
import { LogoMark } from "@/components/Logo";
import { Seo } from "@/components/Seo";

const CGU = `
## 1. Objet

Les présentes conditions générales ont pour objet de définir les modalités et conditions d'utilisation des services proposés sur le site (ci-après : les « Services »), ainsi que de définir les droits et obligations des parties dans ce cadre.

Elles peuvent être complétées, le cas échéant, par des conditions d'utilisation particulières ou des conventions spécifiques à certains Services. En cas de contradiction, les conditions particulières prévalent sur ces conditions générales.

## 2. Exploitant des Services

Les Services sont exploités par la société LMBS, société par actions simplifiée au capital social de 250 euros, immatriculée au RCS de Fort-de-France sous le n° 131890709, représentée par sa présidente Lorina BOUTRIN, dont le siège social est situé 99 Tivoli Post-Colon 97234 Fort-de-France (ci-après : « Gestimmony »).

Gestimmony peut être contactée aux coordonnées suivantes :
- Adresse postale : 99 Tivoli Post Colon 97234 Fort-de-France
- Adresse électronique : contact@gestimmony.fr

## 3. Accès au site et aux Services

Les Services sont accessibles, sous réserve des restrictions prévues sur le site :
- à toute personne physique disposant de la pleine capacité juridique pour s'engager au titre des présentes conditions générales. La personne physique qui ne dispose pas de la pleine capacité juridique ne peut accéder au Site et aux Services qu'avec l'accord de son représentant légal ;
- à toute personne morale agissant par l'intermédiaire d'une personne physique disposant de la capacité juridique pour contracter au nom et pour le compte de la personne morale.

## 4. Acceptation des conditions générales

Avant de consulter les pages et d'utiliser les Services du Site l'Utilisateur doit accepter les présentes Conditions. Son acceptation des Conditions résultera soit :
- d'un clic sur la case « Je valide les conditions générales d'utilisation » ;
- de sa consultation effective des pages du site.

## 5. Description des Services

L'Utilisateur a accès aux Services décrits sur le site, sous une forme et selon les fonctionnalités et moyens techniques que Gestimmony juge les plus appropriés.

## 6. Services payants

**6.1 Prix**

Le prix des Services est indiqué sur le site. Sauf mention contraire, ils sont exprimés en euros. Gestimmony se réserve le droit, à sa libre discrétion et selon des modalités dont elle sera seule juge, de proposer des offres promotionnelles ou réductions de prix.

**6.2 Révision des prix**

Le prix de Services peut faire l'objet d'une révision par Gestimmony à tout moment, à sa libre discrétion.

**6.3 Facturation**

Les Services font l'objet de factures qui sont communiquées automatiquement à l'Utilisateur par courrier électronique ou le cas échéant sur demande expresse de sa part, en adressant un courrier électronique à l'adresse facturation@gestimmony.fr.

**6.4 Modalités de paiement**

Les modalités de paiement du prix des Services sont décrites sur le site. Le paiement s'effectue par prélèvement automatique à partir du numéro de carte bancaire de l'Utilisateur, ou de tout autre moyen de paiement prévu conventionnellement pour certains services.

Le prélèvement est mis en œuvre par le prestataire de paiement désigné sur le site, qui seul conserve les coordonnées bancaires de l'Utilisateur à cette fin. Gestimmony ne conserve aucune coordonnée bancaire. L'Utilisateur garantit à Gestimmony qu'il dispose des autorisations nécessaires pour utiliser le mode de paiement choisi. Il s'engage à prendre les mesures nécessaires afin que le prélèvement automatique du prix des Services puisse être effectué.

**6.5 Droit de rétractation**

Conformément à la réglementation l'Utilisateur bénéficie d'un délai de rétractation de 14 jours à compter du paiement sur le site. Sont néanmoins exclus de droit de rétractation conformément à l'article L121-21-8 du code de la consommation :
- l'édition et le téléchargement du bail de location quelle que soit la formule retenue ;
- l'édition et le téléchargement de l'état des lieux quelle que soit la formule retenue.

Pour exercer ce droit de rétractation, vous devez formuler votre demande uniquement via courrier électronique adressé à facturation@gestimmony.fr.

**6.6 Annulation - Résiliation**

Les offres d'abonnement sont annulables à tout moment via l'interface du site ou par courrier électronique adressée à facturation@gestimmony.fr. À défaut d'annulation avant chaque échéance mensuelle, trimestrielle ou annuelle, l'offre est reconduite tacitement pour la prochaine échéance. Toute échéance payée est acquise en totalité à Gestimmony. Toutefois, l'Utilisateur peut demander la résiliation de son abonnement à tout moment.

## 7. Obligations de l'Utilisateur

Sans préjudice des autres obligations prévues aux présentes, l'Utilisateur s'engage à respecter les obligations qui suivent :

**7.1** L'Utilisateur s'engage, dans son usage des Services, à respecter les lois et règlements en vigueur et à ne pas porter atteinte aux droits de tiers ou à l'ordre public. Il est notamment seul responsable du respect des règles relatives aux baux d'habitation lors de son utilisation des Services. La responsabilité de Gestimmony ne pourra en aucun cas être engagée à ce titre.

**7.2** L'Utilisateur reconnaît avoir pris connaissance sur le site des caractéristiques et contraintes, notamment techniques, de l'ensemble des Services. Il est seul responsable de son utilisation des Services.

**7.3** L'Utilisateur est informé et accepte que la mise en œuvre des Services nécessite qu'il soit connecté à internet et que la qualité des Services dépend directement de cette connexion, dont il est seul responsable.

**7.4** L'Utilisateur est également seul responsable des relations qu'il pourra nouer avec les autres Utilisateurs et des informations qu'il leur communique dans le cadre des Services. Il lui appartient d'exercer la prudence et le discernement appropriés dans ces relations et communications.

**7.5** L'Utilisateur s'engage à faire un usage strictement personnel des Services. Il s'interdit en conséquence de céder, concéder ou transférer tout ou partie de ses droits ou obligations au titre des présentes à un tiers, de quelque manière que ce soit.

**7.6** L'Utilisateur s'engage à fournir à Gestimmony toutes les informations nécessaires à la bonne exécution des Services. Plus généralement, l'Utilisateur s'engage à coopérer activement avec Gestimmony en vue de la bonne exécution des présentes.

**7.7** L'Utilisateur est seul responsable des contenus de toute nature (rédactionnels, graphiques, audiovisuels, fichiers ou autres) qu'il diffuse ou saisis dans le cadre des Services (ci-après désignés : les « Données »). Il garantit à Gestimmony qu'il dispose de tous les droits et autorisations nécessaires à la diffusion de ces Données. Il s'engage à ce que lesdites Données soient licites, ne portent pas atteinte à l'ordre public, aux bonnes mœurs ou aux droits de tiers, n'enfreignent aucune disposition législative ou règlementaire et plus généralement, ne soient aucunement susceptibles de mettre en jeu la responsabilité civile ou pénale de Gestimmony.

**7.8** L'Utilisateur reconnaît que les Services lui offrent une solution supplémentaire mais non alternative des moyens qu'il utilise déjà par ailleurs pour atteindre le même objectif et que cette solution ne saurait se substituer à ces autres moyens.

## 8. Confidentialité - Sauvegarde

Le traitement des données personnelles de l'Utilisateur est régi par la Politique de Confidentialité. L'Utilisateur reconnaît et accepte expressément :
- que les Données recueillies sur le site et sur les équipements informatiques de Gestimmony font foi de la réalité des opérations intervenues dans le cadre des présentes ;
- que ces Données constituent le seul mode de preuve admis entre les parties, notamment pour le calcul des sommes dues à Gestimmony.

Gestimmony ne fournit aucune garantie sur la conservation des Données (informations ou fichiers) transmis par l'Utilisateur. L'Utilisateur doit donc prendre les mesures nécessaires pour sauvegarder les Données transmises.

## 9. Garantie de l'Utilisateur

L'Utilisateur garantit Gestimmony contre toutes plaintes, réclamations, actions et/ou revendications quelconques que Gestimmony pourrait subir du fait de la violation, par l'Utilisateur de l'une quelconque de ses obligations ou garanties aux termes des présentes conditions générales. Il s'engage à indemniser Gestimmony de tout préjudice qu'elle subirait et à lui payer tous les frais, charges et/ou condamnations qu'elle pourrait avoir à supporter de ce fait.

## 10. Comportements prohibés

**10.1** Il est strictement interdit d'utiliser les Services aux fins suivantes :
- l'exercice d'activités illégales, frauduleuses ou portant atteinte aux droits ou à la sécurité des tiers ;
- l'atteinte à l'ordre public ou la violation des lois et règlements en vigueur ;
- l'intrusion dans le système informatique d'un tiers ou toute activité de nature à nuire, contrôler, interférer, ou intercepter tout ou partie du système informatique d'un tiers, en violer l'intégrité ou la sécurité ;
- l'envoi d'emails non sollicités et/ou de prospection ou sollicitation commerciale ;
- les manipulations destinées à améliorer le référencement d'un site tiers ;
- l'aide ou l'incitation, sous quelque forme et de quelque manière que ce soit, à un ou plusieurs des actes et activités décrits ci-dessus ;
- et plus généralement toute pratique détournant les Services à des fins autres que celles pour lesquelles ils ont été conçus.

**10.2** Il est strictement interdit aux Utilisateurs de copier et/ou de détourner à leurs fins ou à celles de tiers le concept, les technologies ou tout autre élément du site de Gestimmony.

**10.3** Sont également strictement interdits : (i) tous comportements de nature à interrompre, suspendre, ralentir ou empêcher la continuité des Services, (ii) toutes intrusions ou tentatives d'intrusions dans les systèmes de Gestimmony, (iii) tous détournements des ressources système du site, (iv) toutes actions de nature à imposer une charge disproportionnée sur les infrastructures de ce dernier, (v) toutes atteintes aux mesures de sécurité et d'authentification, (vi) tous actes de nature à porter atteinte aux droits et intérêts financiers, commerciaux ou moraux de Gestimmony ou des usagers de son site, et enfin plus généralement (vii) tout manquement aux présentes conditions générales.

**10.4** Il est strictement interdit de monnayer, vendre ou concéder tout ou partie de l'accès aux Services ou au site, ainsi qu'aux informations qui y sont hébergées et/ou partagées.

## 11. Sanctions des manquements

En cas de manquement à l'une quelconque des dispositions des présentes conditions générales ou plus généralement, d'infraction aux lois et règlements en vigueur par un Utilisateur, Gestimmony se réserve le droit de prendre toute mesure appropriée et notamment de :
- suspendre ou empêcher l'accès aux Services de l'Utilisateur, auteur du manquement ou de l'infraction, ou y ayant participé ;
- supprimer tout contenu mis en ligne sur le site ;
- publier sur le site tout message d'information que Gestimmony jugera utile ;
- avertir toute autorité concernée ;
- engager toute action judiciaire.

## 12. Responsabilité et garantie de Gestimmony

**12.1** Gestimmony s'engage à fournir les Services avec diligence et selon les règles de l'art, étant précisé qu'il pèse sur elle une obligation de moyens, à l'exclusion de toute obligation de résultat, ce que les Utilisateurs reconnaissent et acceptent expressément.

**12.2** Gestimmony n'a pas connaissance des Données mises en ligne et saisies par les Utilisateurs dans le cadre des Services, sur lesquels elle n'effectue aucune modération, sélection, vérification ou contrôle d'aucune sorte et à l'égard desquels elle n'intervient qu'en tant que prestataire d'hébergement. En conséquence, Gestimmony ne peut être tenue pour responsable des Données, dont les auteurs sont des tiers, toute réclamation éventuelle devant être dirigée en premier lieu vers l'auteur des Données en question. Les Données préjudiciables à un tiers peuvent faire l'objet d'une notification à Gestimmony selon les modalités prévues par l'article 6-I-5 de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique, Gestimmony se réservant de prendre les mesures décrites à l'article 11.

**12.3** Gestimmony ne garantit pas aux Utilisateurs que les méthodes et contenus suggérés par Gestimmony lors de l'Utilisation des Services répondent aux besoins de l'Utilisateur et aux réglementations et lois qui lui seraient applicables. L'Utilisateur est donc seul responsable de l'utilisation finale qu'il fait de ces contenus suggérés, Gestimmony n'ayant pas de mandat pour gérer tout ou partie des locations ou mises en locations pour le compte de l'Utilisateur. Gestimmony attire notamment l'attention de l'Utilisateur sur la nécessité d'utiliser des clauses résolutoires et de solidarité dans le cadre du bail de location. Gestimmony rappelle enfin à l'Utilisateur la nécessité de respecter les conditions générales des contrats d'assurances souscrites par son intermédiaire.

**12.4** Gestimmony décline toute responsabilité en cas de perte éventuelle des informations accessibles lors de l'utilisation des Services, celui-ci devant en sauvegarder une copie et ne pouvant prétendre à aucun dédommagement à ce titre.

**12.5** Gestimmony s'engage à procéder régulièrement à des contrôles afin de vérifier le fonctionnement et l'accessibilité du site. À ce titre, Gestimmony se réserve la faculté d'interrompre momentanément l'accès au site pour des raisons de maintenance. De même, Gestimmony ne saurait être tenue responsable des difficultés ou impossibilités momentanées d'accès au site qui auraient pour origine des circonstances qui lui sont extérieures, la force majeure, ou encore qui seraient dues à des perturbations des réseaux de télécommunication.

**12.6** Gestimmony ne garantit pas aux Utilisateurs (i) que les Services, soumis à une recherche constante pour en améliorer notamment la performance et le progrès, seront totalement exempts d'erreurs, de vices ou défauts, (ii) que les Services, étant standard et nullement proposés à la seule intention d'un Utilisateur donné en fonction de ses propres contraintes personnelles, répondront spécifiquement à ses besoins et attentes.

**12.7** En tout état de cause, la responsabilité susceptible d'être encourue par Gestimmony au titre des présentes est expressément limitée aux seuls dommages directs avérés subis par l'Utilisateur.

## 13. Propriété intellectuelle

Les systèmes, logiciels, structures, infrastructures, bases de données et contenus de toute nature (textes, images, visuels, musiques, logos, marques, base de données, etc.) exploités par Gestimmony au sein du site sont protégés par tous droits de propriété intellectuelle ou droits des producteurs de bases de données en vigueur. Tous désassemblages, décompilations, décryptages, extractions, réutilisations, copies et plus généralement, tous actes de reproduction, représentation, diffusion et utilisation de l'un quelconque de ces éléments, en tout ou partie, sans l'autorisation de Gestimmony sont strictement interdits et pourront faire l'objet de poursuites judiciaires.

## 14. Modifications

Gestimmony se réserve la faculté de modifier à tout moment les présentes conditions générales. L'Utilisateur sera informé de ces modifications par tout moyen utile. Tout Utilisateur qui a recours aux Services postérieurement à l'entrée en vigueur des conditions générales modifiées est réputé avoir accepté ces modifications.

## 15. Langue

Dans l'hypothèse d'une traduction des présentes conditions générales dans une ou plusieurs langues, la langue d'interprétation sera la langue française en cas de contradiction ou de contestation sur la signification d'un terme ou d'une disposition.

## 16. Loi applicable et juridiction

Les présentes conditions générales sont régies par la loi française. En cas de contestation sur la validité, l'interprétation et/ou l'exécution des présentes conditions générales, les parties conviennent que les tribunaux de Fort-de-France seront exclusivement compétents pour en juger, sauf règles de procédure impératives contraires.

## 17. Entrée en vigueur

Les présentes conditions générales sont entrées en vigueur le 22 octobre 2026.
`;

const CONFIDENTIALITE = `
## 1. Introduction

La présente politique de confidentialité a pour objectif d'informer les utilisateurs du site Gestimmony.fr (le « Site ») et du logiciel de gestion locative (le « Service ») sur la manière dont leurs données personnelles sont collectées, traitées et protégées, conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés du 6 janvier 1978 modifiée.

## 2. Identité du responsable du traitement

Le site Gestimmony.fr est exploité par LMBS, responsable du traitement des données personnelles collectées via ses services.

- Adresse : 99 bis Tivoli Post-Colon 97234 Fort-de-France
- N° d'immatriculation : 131890709 RCS Fort-de-France — SIREN 131890709
- Représentant légal : Lorina BOUTRIN
- Email : contact@gestimmony.fr

## 3. Catégories de données, finalités, bases légales et sous-traitants

Le tableau ci-dessous synthétise les traitements réalisés par Gestimmony.

**Données d'identification** (nom, prénom, e-mail, téléphone, mot de passe chiffré)
- Finalités : création et gestion du compte utilisateur, communications de service, support client
- Base légale : exécution du contrat
- Sous-traitants / Outils : OVH (hébergement), Zoho (e-mails)
- Durée de conservation : minimum des durées de conservation des contrats de location, états des lieux et dossiers locataires rattachés au compte

**Contrats de location** (adresse du logement, infos bailleur/locataire, loyer, annexes, etc.)
- Finalités : rédaction des documents contractuels et gestion locative des logements
- Base légale : exécution du contrat ; obligation légale
- Sous-traitants / Outils : OVH, Emergent IA, Zoho, Yousign (signature électronique)
- Durée de conservation : baux non rattachés à un compte ou supprimés : 90 jours ; baux gratuits : 3 ans après la dernière mise à jour ; baux payants : 5 ans après le dernier paiement ; dossier de preuves et baux signés chez Yousign : 10 ans

**États des lieux** (adresse du logement, infos bailleur, état du logement, photos, etc.)
- Finalités : rédaction des documents contractuels et gestion locative des logements
- Base légale : exécution du contrat ; obligation légale
- Sous-traitants / Outils : OVH, Emergent IA, Zoho
- Durée de conservation : état des lieux rattaché à un bail : même durée que le bail ; état des lieux non rattaché à un bail : 30 jours après la dernière mise à jour

**Dossiers locataires** (prénom, nom, e-mail, revenus, statut, justificatifs)
- Finalités : gestion de la fraude documentaire ; courtage en assurance loyer impayé
- Base légale : intérêt légitime ; mesures précontractuelles
- Sous-traitants / Outils : Emergent IA, OVH
- Durée de conservation : dossiers soumis à vérification : 10 ans ; autres dossiers : 3 mois

**Paiement**
- Finalités : gestion des abonnements et paiements
- Base légale : exécution du contrat ; obligation légale (facturation)
- Sous-traitants / Outils : OVH ; Stripe* (carte bancaire) ; Emergent IA
- Durée de conservation : durée définie par le prestataire et nécessaire à la fourniture du service

**Logs techniques et données de connexion** (IP, date, erreurs)
- Finalités : sécurité du site, gestion et résolution des bugs, indicateurs généraux
- Base légale : intérêt légitime
- Sous-traitants / Outils : OVH ; Emergent IA
- Durée de conservation : 10 ans

**Support client et messages**
- Finalités : réponses aux demandes et assistance
- Base légale : intérêt légitime ; consentement implicite ; exécution du contrat
- Sous-traitants / Outils : Emergent IA
- Durée de conservation : 10 ans

**Données de signature électronique** (fichiers signés, dossier de preuves)
- Finalités : signature électronique des baux et de leurs annexes
- Base légale : obligation légale ; exécution du contrat
- Sous-traitants / Outils : Emergent IA, Yousign
- Durée de conservation : 10 ans

**Mesures d'audience** (sans cookies)
- Finalités : indicateurs généraux sur les visiteurs du site
- Base légale : intérêt légitime
- Sous-traitants / Outils : Emergent analytics
- Durée de conservation : durée définie par le prestataire et nécessaire à la fourniture du service

(*) Transferts hors UE : certains prestataires (ex. Stripe) sont situés hors de l'Union européenne. Lorsqu'ils sont certifiés dans le cadre de l'EU-US Data Privacy Framework, la Commission européenne considère que la protection est adéquate (décision du 10 juillet 2023). En l'absence de décision d'adéquation, des garanties appropriées sont mises en place (clauses contractuelles types).

## 4. Vos droits

Vous disposez des droits d'accès, de rectification, d'effacement, de limitation, d'opposition, de portabilité, ainsi que du droit de définir des directives post-mortem. Lorsque la base légale est le consentement, vous pouvez le retirer à tout moment.

Vous pouvez exercer vos droits à l'adresse indiquée ci-dessous. Vous avez également le droit d'introduire une réclamation auprès de la CNIL.

## 5. Sécurité

Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger les données personnelles (contrôle d'accès, chiffrement des mots de passe, journalisation, sauvegardes, revue des sous-traitants, etc.).

## 6. Mesures d'audience et cookies

Nous utilisons uniquement des cookies et traceurs strictement nécessaires au bon fonctionnement du site et à la fourniture du service demandé par l'utilisateur.

Ces cookies techniques permettent par exemple de maintenir votre session ouverte, d'assurer la sécurité de l'authentification et le bon affichage des pages. Ils ne sont pas soumis à votre consentement préalable conformément aux recommandations de la CNIL.

Aucun cookie tiers, publicitaire, de mesure d'audience ni de suivi comportemental n'est déposé sur votre appareil. Par conséquent, aucune bannière de consentement n'est affichée lors de votre visite.

Vous pouvez toutefois configurer votre navigateur pour bloquer ou supprimer ces cookies essentiels, mais certaines fonctionnalités du site risquent alors de ne plus fonctionner correctement.

## 7. Contact RGPD

Pour toute question ou pour exercer vos droits : contact@gestimmony.fr ou courrier postal à l'adresse du responsable ci-dessus.
`;

const MENTIONS = `
## 1. Éditeur du site

Le site Gestimmony.fr et le logiciel de gestion locative associé sont édités par la société **LMBS**, société par actions simplifiée au capital social de 250 euros, immatriculée au RCS de Fort-de-France sous le n° 131890709 (SIREN 131890709).

- Siège social : 99 bis Tivoli Post-Colon, 97234 Fort-de-France
- Présidente et directrice de la publication : Lorina BOUTRIN
- Adresse électronique : contact@gestimmony.fr

## 2. Hébergement

Le site et les données sont hébergés par **OVH SAS**, société dont le siège social est situé 2 rue Kellermann, 59100 Roubaix (France).

## 3. Propriété intellectuelle

L'ensemble des éléments du site (structure, textes, logos, marques, visuels, base de données, code source) est protégé par le droit de la propriété intellectuelle et demeure la propriété exclusive de LMBS. Toute reproduction, représentation, modification ou exploitation, totale ou partielle, sans autorisation écrite préalable est interdite et susceptible de poursuites.

## 4. Données personnelles

Le traitement des données personnelles des utilisateurs est décrit dans la Politique de confidentialité accessible sur le site. Conformément au RGPD et à la loi Informatique et Libertés, vous disposez de droits d'accès, de rectification, d'effacement, d'opposition et de portabilité, que vous pouvez exercer à l'adresse contact@gestimmony.fr. Vous pouvez également introduire une réclamation auprès de la CNIL.

## 5. Cookies

Le site n'utilise que des cookies strictement nécessaires à son fonctionnement et à la sécurité de l'authentification. Aucun cookie publicitaire ou de mesure d'audience tiers n'est déposé (voir la Politique de confidentialité).

## 6. Médiation de la consommation

Conformément aux articles L.612-1 et suivants du Code de la consommation, le consommateur a le droit de recourir gratuitement à un médiateur de la consommation en vue de la résolution amiable d'un litige qui l'opposerait à LMBS. Toute réclamation préalable doit être adressée à facturation@gestimmony.fr.

## 7. Droit applicable

Les présentes mentions légales sont régies par le droit français. Tout litige relatif à leur interprétation ou à leur exécution relève de la compétence des tribunaux de Fort-de-France.
`;

function renderMarkdown(md) {
  // Very small markdown → HTML for headings, paragraphs, bold, lists
  const lines = md.trim().split("\n");
  const out = [];
  let listBuffer = [];
  const flushList = () => {
    if (listBuffer.length) {
      out.push(<ul key={`ul-${out.length}`} className="list-disc pl-6 space-y-1 my-3 text-slate-700">{listBuffer}</ul>);
      listBuffer = [];
    }
  };
  lines.forEach((line, i) => {
    const l = line.trim();
    if (!l) { flushList(); return; }
    if (l.startsWith("## ")) {
      flushList();
      out.push(<h3 key={i} className="font-heading text-lg font-semibold text-slate-900 mt-6 mb-2">{l.replace("## ", "")}</h3>);
    } else if (l.startsWith("- ")) {
      listBuffer.push(<li key={i} dangerouslySetInnerHTML={{ __html: l.slice(2).replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>") }} />);
    } else {
      flushList();
      out.push(<p key={i} className="text-slate-700 leading-relaxed my-2" dangerouslySetInnerHTML={{ __html: l.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>") }} />);
    }
  });
  flushList();
  return out;
}

export default function LegalPage({ defaultTab = "cgu" }) {
  const [tab, setTab] = useState(defaultTab);

  const SEO = {
    cgu: { title: "Conditions générales d'utilisation — Gestimmony", description: "Les conditions générales d'utilisation du logiciel de gestion locative Gestimmony.", path: "/cgu" },
    confidentialite: { title: "Politique de confidentialité (RGPD) — Gestimmony", description: "Comment Gestimmony collecte, utilise et protège vos données personnelles. Données hébergées en France, conformité RGPD.", path: "/confidentialite" },
    mentions: { title: "Mentions légales — Gestimmony (LMBS, SIREN 131 890 709)", description: "Éditeur : LMBS SAS, SIREN 131 890 709, RCS Fort-de-France. Siège : 99 Tivoli Post-Colon, 97234 Fort-de-France. Hébergeur : OVH (France).", path: "/mentions-legales" },
  }[tab] || {};

  return (
    <div className="min-h-screen bg-[hsl(var(--background))]">
      <Seo title={SEO.title} description={SEO.description} path={SEO.path} />
      <header className="border-b border-stone-200 bg-white/80 backdrop-blur sticky top-0 z-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <LogoMark className="h-8" />
            <span className="font-heading font-bold">Gestimmony</span>
          </Link>
          <Link to="/" className="text-sm text-slate-600 hover:text-[hsl(var(--primary))] inline-flex items-center gap-1.5">
            <ArrowLeft className="h-4 w-4" /> Retour
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight text-slate-900" data-testid="legal-title">
          Informations légales
        </h1>
        <p className="mt-2 text-slate-500 text-sm">
          Conditions générales d'utilisation et politique de confidentialité.
        </p>

        <Tabs value={tab} onValueChange={setTab} className="mt-8">
          <TabsList className="bg-white border border-stone-200 p-1 rounded-full flex flex-wrap gap-1 h-auto">
            <TabsTrigger value="cgu" data-testid="tab-cgu" className="rounded-full data-[state=active]:bg-[hsl(var(--primary))] data-[state=active]:text-white">CGU</TabsTrigger>
            <TabsTrigger value="confidentialite" data-testid="tab-confidentialite" className="rounded-full data-[state=active]:bg-[hsl(var(--primary))] data-[state=active]:text-white">Confidentialité</TabsTrigger>
            <TabsTrigger value="mentions" data-testid="tab-mentions" className="rounded-full data-[state=active]:bg-[hsl(var(--primary))] data-[state=active]:text-white">Mentions légales</TabsTrigger>
          </TabsList>

          <Card className="mt-6 p-6 sm:p-8 border-stone-200 shadow-none">
            <TabsContent value="cgu" className="mt-0" data-testid="legal-cgu-content">{renderMarkdown(CGU)}</TabsContent>
            <TabsContent value="confidentialite" className="mt-0" data-testid="legal-confidentialite-content">{renderMarkdown(CONFIDENTIALITE)}</TabsContent>
            <TabsContent value="mentions" className="mt-0" data-testid="legal-mentions-content">{renderMarkdown(MENTIONS)}</TabsContent>
          </Card>
        </Tabs>

        <p className="mt-8 text-xs text-slate-400">
          Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}
        </p>
      </main>
    </div>
  );
}
